import React from "react";
import {EditCommentsModal} from "../../../client/EditCommentsModal";
import {DashboardCell} from "./base/DashboardCell";

export class DashboardCommentsCell extends DashboardCell {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            formattedValue: this.props.formattedValue
        };
        this.handleCommentsModified = this.handleCommentsModified.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({
                value: this.props.value,
                formattedValue: this.props.formattedValue
            });
        }
    }

    handleCommentsModified(data) {
        this.setState({
            value: data,
            formattedValue: data
        })
    }

    render() {
        return (
            <td className={`single-editable-data ${this.processingCssClasses()}`}>
                {this.renderCellContent()}
            </td>
        )
    }

    removePageBreaks(text) {
        // Remove form feed characters
        let cleanedText = text.replace(/\f/g, '');
        // Remove double newlines (assuming they're used as page breaks)
        cleanedText = cleanedText.replace(/\n/g, '');
        // If HTML-based page breaks (like <hr>) are used, remove them as well
        cleanedText = cleanedText.replace(/<hr>/g, '');
        return cleanedText;
    }

    renderText() {
        let text = this.state.formattedValue
        if(text === null)
            text = "";

        let cleanedText = this.removePageBreaks(text);

        if(cleanedText.length > 15) {
            cleanedText = cleanedText.substring(0, 15);
            cleanedText = cleanedText + '...';
        }

        return cleanedText;
    }

    renderCellContent() {
        return <div className="bu-cell editable">
            <div className="comment-in-cell">{this.renderText()}</div>
            {this.props.readOnly
                ? <div style={{minWidth:"25px"}}></div>
                : <EditCommentsModal onFormSubmitted={this.handleCommentsModified}
                                     businessUnitId={this.props.businessUnitId}
                                     campaignsConfigurationId={this.props.campaignsConfigurationId}
                                     campaignId={this.props.campaignId}
                                     adgroupId={this.props.adgroupId}
                                     value={this.props.value}
                                     clickOutsideDontCloseModal={true}
                  />}
        </div>;
    }
}
